<lx-selector-field-container
  i18n-label
  label="Course"
  [disabled]="disabled"
  [empty]="!selectedValue"
  [selectorFieldHandler]="openSelectorClickHandler"
  data-qa="ayaCourseSelector_field"
>
  {{ selectedValue ? selectedValue.name : emptySelectionMsg }}
</lx-selector-field-container>

<lx-side-panel i18n-title title="Select a course" [visible]="dialogVisible" (hiddenPanel)="hideDialog()" size="large" data-qa="ayaCourseSelector_sidePanel">
  <lx-aya-course-selector [visible]="dialogVisible" (selectedCourseChanged)="handleSelectedValue($event)" data-qa="ayaCourseSelector"> </lx-aya-course-selector>
</lx-side-panel>
